import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { map } from 'lodash';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';

import './PermutationsTable.scss';
import { select } from '../../../configs/store';
import formatOdds from '../../../utils/formatOdds';

class PermutationsTable extends PureComponent {

  async componentDidMount() {
    await this.props.getPossiblePermutations();
  }

  render() {
    const { t, possiblePermutations, combinationsMatrix, selectedOddsType } = this.props;

    return (
      <div className="permutations-table-container">
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">{ t('permutationsTable.betLine') }</TableCell>
              {
                possiblePermutations ? map(new Array(possiblePermutations.outcomesCount), (outcome, index) =>
                  <TableCell align="center" key={ index }>{ index + 1 }</TableCell>
                ) : map(Object.keys(combinationsMatrix), (combination, i) =>
                  <TableCell align="center" key={ i }>{ i + 1 }</TableCell>
                )
              }
              <TableCell align="center" className="permutations-table-container__header">{ t('permutationsTable.odds') }</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              map(Object.keys(combinationsMatrix), (combination, i) => {
                return (
                  <TableRow key={ i }>
                    <TableCell align="center" className="permutations-table-container__cell">{ i + 1 }</TableCell>
                    {
                      map(combinationsMatrix[combination].outcomes, (value, j) => <TableCell align="center" key={ j }>{ value }</TableCell>)
                    }
                    <TableCell align="center" className="permutations-table-container__cell">
                      { formatOdds(combinationsMatrix[combination].odds, selectedOddsType) }
                    </TableCell>
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </div>
    );
  }

}

PermutationsTable.propTypes = {
  t: PropTypes.func,
  getPossiblePermutations: PropTypes.func,
  possiblePermutations: PropTypes.object,
  combinationsMatrix: PropTypes.object,
  selectedOddsType: PropTypes.string
};

const selection = select(state => ({
  combinationsMatrix: state.betslip.combinationsMatrix
}));

const mapState = state => ({
  possiblePermutations: state.betslip.possiblePermutations,
  selectedOddsType: state.odds.selectedOddsType,
  ...selection(state)
});

const mapDispatch = dispatch => ({
  getPossiblePermutations: () => dispatch.betslip.getPossiblePermutations()
});

export default connect(mapState, mapDispatch)(withTranslation('common')(PermutationsTable));
